import * as React from "react"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { cn } from "@/lib/utils"

// A studio sheet: the design-system Radix Dialog with the `studio-sheet`
// styling. On the phone it is a bottom sheet (pinned to the foot of the
// screen, hairline top, grab bar); from 1024 px it is a centred dialog, which
// is how the template gallery and the ornament menu open from the desktop
// rail. Focus trap, Escape and outside-tap closing come from Radix.

export function StudioSheet({
  open,
  onOpenChange,
  title,
  description,
  size = "default",
  children,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description?: string
  /** Desktop width: "wide" for the template gallery, "narrow" for short sheets. */
  size?: "default" | "wide" | "narrow"
  children: React.ReactNode
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={cn(
          "studio-sheet",
          size === "wide" && "studio-sheet-wide",
          size === "narrow" && "studio-sheet-narrow",
        )}
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description ? (
            <DialogDescription>{description}</DialogDescription>
          ) : (
            <DialogDescription className="sr-only">{title}</DialogDescription>
          )}
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  )
}
